export default "__VITE_ASSET__Cs78TOuf__"